// activeCalibrationLogBook/activeCalibrationLogBookActions.js

import { getCalibrationLogBookById } from "../../api/CalibrationLogsApi";
import { CalibrationLogBook } from "../../models/CalibrationLogBook/CalibrationLogBook";
import { activeCalibrationLogBookInitialState } from "./activeCalibrationLogBookState";
import { makeCalibrationLogBookFormActions } from "../forms/calibrationLogBookForm/calibrationLogBookFormActions";

export const makeActiveCalibrationLogBookActions = (set, get) => ({
  fetchActiveCalibrationLogBook: async (bookId) => {
    set((s) => ({
      activeCalibrationLogBook: {
        ...s.activeCalibrationLogBook,
        isLoading: true,
        error: null,
      },
    }));

    try {
      const response = await getCalibrationLogBookById(bookId);
      const rawData = response?.data || response;

      if (rawData && rawData.calibration_log_book) {
        const bookInstance = new CalibrationLogBook(rawData.calibration_log_book);
        set((s) => ({
          activeCalibrationLogBook: {
            ...s.activeCalibrationLogBook,
            isLoading: false,
            currentBook: bookInstance,
            _rev: 0,
          },
        }));
        return { ok: true };
      }

      throw new Error("Invalid calibration log book data received from server.");
    } catch (error) {
      const message = error?.message || "Failed to load calibration log book";
      set((s) => ({
        activeCalibrationLogBook: {
          ...s.activeCalibrationLogBook,
          isLoading: false,
          error: message,
          currentBook: null,
        },
      }));
      try {
        get().notificationActions?.showNotification?.({
          type: "error",
          title: "Error Loading Calibration Log Book",
          message,
        });
      } catch {}
      // Return a string message (never the raw error object) so callers can safely
      // render it (e.g. in a notification) without hitting React error #31.
      return { ok: false, error: message };
    }
  },

  /**
   * Apply a websocket patch by delegating to calibrationLogBookFormActions.handleBroadcast.
   */
  applyWebsocketPatch: (patchData) => {
    const current = get().activeCalibrationLogBook.currentBook;
    if (!current) return;

    const formActions =
      get().activeCalibrationLogBookActions?.calibrationLogBookFormActions;
    if (formActions?.handleBroadcast) {
      formActions.handleBroadcast(patchData);
    } else {
      console.warn(
        "activeCalibrationLogBookActions.calibrationLogBookFormActions.handleBroadcast not available"
      );
    }

    set((s) => ({
      activeCalibrationLogBook: {
        ...s.activeCalibrationLogBook,
        _rev: (s.activeCalibrationLogBook._rev || 0) + 1,
      },
    }));
  },

  clearActiveBook: () =>
    set(() => ({
      activeCalibrationLogBook: {
        ...activeCalibrationLogBookInitialState,
      },
    })),

  calibrationLogBookFormActions: Object.freeze(
    makeCalibrationLogBookFormActions(set, get)
  ),
});
